/**
 * NotSupportedError
 */ export class NotSupportedError extends Error {
    constructor(name, message){
        super();
        this.message = `${name}${message ? " " + message : ""}`;
        this.name = "NotSupportedError";
    }
}
